export type UpdateCallback = (dt: number) => void;

export class GameLoop {
  private lastTime = 0;
  private accumulator = 0;
  private running = false;
  private rafId = 0;

  readonly TICK_RATE = 1000 / 30;

  private logicCallbacks: UpdateCallback[] = [];
  private renderCallbacks: UpdateCallback[] = [];

  onLogic(cb: UpdateCallback): void {
    this.logicCallbacks.push(cb);
  }

  onRender(cb: UpdateCallback): void {
    this.renderCallbacks.push(cb);
  }

  start(): void {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now();
    this.accumulator = 0;
    this.rafId = requestAnimationFrame((t) => this.tick(t));
  }

  stop(): void {
    this.running = false;
    cancelAnimationFrame(this.rafId);
  }

  private tick(currentTime: number): void {
    if (!this.running) return;

    const delta = Math.min(currentTime - this.lastTime, 1000);
    this.lastTime = currentTime;
    this.accumulator += delta;

    const maxCatchUp = this.TICK_RATE * 30;
    if (this.accumulator > maxCatchUp) {
      this.accumulator = maxCatchUp;
    }

    while (this.accumulator >= this.TICK_RATE) {
      for (const cb of this.logicCallbacks) cb(this.TICK_RATE);
      this.accumulator -= this.TICK_RATE;
    }

    for (const cb of this.renderCallbacks) cb(delta);

    this.rafId = requestAnimationFrame((t) => this.tick(t));
  }
}
